module.exports = __webpack_public_path__ + "img/Fulfilled.f3269cde.svg";